import { useState, useEffect, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../services/api.js'
import { useAuth } from '../services/auth.jsx'

export default function SafrasPage() {
  const { currentFazenda } = useAuth()
  const [safras, setSafras] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [editing, setEditing] = useState(null)

  const fazendaId = currentFazenda?.id

  const fetchSafras = useCallback(async () => {
    if (!fazendaId) { setSafras([]); setLoading(false); return }
    setLoading(true)
    try {
      setSafras(await api.getSafras(fazendaId))
    } catch (e) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }, [fazendaId])

  useEffect(() => { fetchSafras() }, [fetchSafras])

  async function act(fn) {
    try { await fn(); await fetchSafras() } catch (e) { setError(e.message) }
  }

  const setCurrent = (s) => act(() => api.updateSafra(s.id, { is_current: true }, fazendaId))
  const toggleClosed = (s) => act(() => api.updateSafra(s.id, { closed: !s.closed }, fazendaId))
  const del = (s) => {
    if (!window.confirm(`Excluir a safra "${s.name}" e todas as suas áreas/registros? Esta ação não pode ser desfeita.`)) return
    act(() => api.deleteSafra(s.id, fazendaId))
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f0fdf4' }}>
      {/* Header */}
      <div style={{ background: '#14532d', padding: '0 24px', height: 60, display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ color: '#86efac', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}>← Dashboard</Link>
        <span style={{ color: 'rgba(255,255,255,0.3)' }}>|</span>
        <span style={{ fontSize: 26 }}>🗓️</span>
        <div style={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>
          Safras {currentFazenda?.name ? `— ${currentFazenda.name}` : ''}
        </div>
        {fazendaId && (
          <button
            onClick={() => { setEditing(null); setShowForm(true) }}
            style={{ marginLeft: 'auto', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 10, padding: '8px 16px', cursor: 'pointer', fontWeight: 700, fontSize: 13 }}
          >
            ➕ Nova Safra
          </button>
        )}
      </div>

      <div style={{ maxWidth: 680, margin: '32px auto', padding: '0 16px' }}>
        {error && (
          <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '12px 16px', borderRadius: 10, fontWeight: 600, fontSize: 13, marginBottom: 16 }}>
            Erro: {error}
            <button onClick={() => setError('')} style={{ marginLeft: 12, background: 'none', border: 'none', cursor: 'pointer', color: '#7f1d1d', fontWeight: 800 }}>×</button>
          </div>
        )}

        {!fazendaId ? (
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, textAlign: 'center', color: '#64748b', fontSize: 14, boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}>
            Selecione uma fazenda no <Link to="/" style={{ color: '#16a34a', fontWeight: 700 }}>Dashboard</Link> para gerenciar as safras.
          </div>
        ) : loading ? (
          <div style={{ textAlign: 'center', color: '#64748b', padding: 40 }}>Carregando...</div>
        ) : (
          <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
            {safras.length === 0 && (
              <div style={{ padding: 32, textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>Nenhuma safra cadastrada.</div>
            )}
            {safras.map((s, idx) => (
              <div key={s.id} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px',
                borderBottom: idx < safras.length - 1 ? '1px solid #e7f3ea' : 'none',
                background: s.closed ? '#f8fafc' : '#fff',
              }}>
                <div style={{ width: 38, height: 38, borderRadius: 999, flexShrink: 0, background: '#052e16', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  {s.closed ? '🔒' : '🌱'}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: 700, color: '#0f172a', fontSize: 14 }}>{s.name}</span>
                    {s.is_current && (
                      <span style={{ fontSize: 10, background: '#dcfce7', color: '#15803d', borderRadius: 999, padding: '1px 8px', fontWeight: 700 }}>atual</span>
                    )}
                    {s.closed && (
                      <span style={{ fontSize: 10, background: '#fef9c3', color: '#713f12', borderRadius: 999, padding: '1px 8px', fontWeight: 700 }}>fechada</span>
                    )}
                  </div>
                  <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{s.area_count ?? 0} área(s)</div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  {!s.is_current && (
                    <button onClick={() => setCurrent(s)} style={actionBtn('#dcfce7', '#15803d')} title="Definir como safra atual">▶</button>
                  )}
                  <button onClick={() => toggleClosed(s)} style={actionBtn(s.closed ? '#dcfce7' : '#fef9c3', s.closed ? '#15803d' : '#713f12')} title={s.closed ? 'Reabrir (permitir edição)' : 'Fechar (somente leitura)'}>
                    {s.closed ? '🔓' : '🔒'}
                  </button>
                  <button onClick={() => { setEditing(s); setShowForm(true) }} style={actionBtn('#f1f5f9', '#475569')} title="Renomear">✏️</button>
                  <button onClick={() => del(s)} style={actionBtn('#fee2e2', '#b91c1c')} title="Excluir">🗑</button>
                </div>
              </div>
            ))}
          </div>
        )}

        {fazendaId && (
          <div style={{ marginTop: 16, fontSize: 12, color: '#64748b', lineHeight: 1.6 }}>
            Uma safra tem seu próprio mapa de áreas. <b>Fechar</b> deixa a safra somente-leitura (histórico); <b>reabrir</b> permite editar de novo.
            Ao criar uma safra nova você pode <b>clonar o mapa</b> de uma safra existente como ponto de partida.
          </div>
        )}
      </div>

      {showForm && (
        <SafraFormModal
          safra={editing}
          safras={safras}
          onSave={async (data) => {
            if (editing) {
              await api.updateSafra(editing.id, { name: data.name }, fazendaId)
            } else {
              await api.createSafra(data, fazendaId)
            }
            await fetchSafras()
            setShowForm(false)
          }}
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  )
}

function SafraFormModal({ safra, safras, onSave, onClose }) {
  const isEdit = !!safra
  const [name, setName] = useState(safra?.name ?? '')
  const [cloneFrom, setCloneFrom] = useState('')   // '' = vazia
  const [setCurrent, setSetCurrent] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSave() {
    if (!name.trim()) return setError('Nome é obrigatório')
    setSaving(true)
    setError('')
    try {
      const payload = isEdit
        ? { name: name.trim() }
        : { name: name.trim(), clone_from_safra_id: cloneFrom ? Number(cloneFrom) : null, set_current: setCurrent }
      await onSave(payload)
    } catch (e) {
      setError(e.message)
      setSaving(false)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div style={{ background: '#14532d', borderRadius: 16, padding: '28px 32px', maxWidth: 420, width: '100%', boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 11, color: '#86efac', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 4 }}>
          {isEdit ? 'Editar Safra' : 'Nova Safra'}
        </div>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 20 }}>
          {isEdit ? '✏️ Renomear safra' : '➕ Adicionar safra'}
        </div>

        <label style={lbl}>Nome da safra *</label>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && isEdit) handleSave() }}
          style={inp}
          placeholder="Ex: Verão 2026/27"
          autoFocus
        />

        {!isEdit && (
          <>
            <label style={{ ...lbl, marginTop: 16 }}>Mapa de áreas</label>
            <select value={cloneFrom} onChange={e => setCloneFrom(e.target.value)} style={inp}>
              <option value="" style={{ background: '#052e16' }}>Começar vazia (sem áreas)</option>
              {safras.map(s => (
                <option key={s.id} value={s.id} style={{ background: '#052e16' }}>Clonar mapa de: {s.name}</option>
              ))}
            </select>

            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 14, color: '#e2f5e9', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
              <input type="checkbox" checked={setCurrent} onChange={e => setSetCurrent(e.target.checked)} />
              Definir como safra atual
            </label>
          </>
        )}

        {error && <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginTop: 12 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={onClose} disabled={saving} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.2)', background: 'transparent', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Cancelar</button>
          <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '10px 0', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
            {saving ? 'Salvando...' : isEdit ? 'Salvar' : 'Criar safra'}
          </button>
        </div>
      </div>
    </div>
  )
}

const lbl = { display: 'block', fontSize: 10, fontWeight: 700, color: '#86efac', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 4 }
const inp = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #16a34a', background: '#052e16', color: '#fff', fontSize: 14, boxSizing: 'border-box', outline: 'none' }

function actionBtn(bg, color) {
  return { background: bg, border: 'none', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 15, color, lineHeight: 1 }
}
